/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Badge_Attempt_FinishedInputs */

const en_course_badge_attempt_finished = /** @type {(inputs: Course_Badge_Attempt_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt finished`)
};

const ja_course_badge_attempt_finished = /** @type {(inputs: Course_Badge_Attempt_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試行完了`)
};

const fr_course_badge_attempt_finished = /** @type {(inputs: Course_Badge_Attempt_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentative terminée`)
};

const de_course_badge_attempt_finished = /** @type {(inputs: Course_Badge_Attempt_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuch abgeschlossen`)
};

/**
* | output |
* | --- |
* | "Attempt finished" |
*
* @param {Course_Badge_Attempt_FinishedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_badge_attempt_finished = /** @type {((inputs?: Course_Badge_Attempt_FinishedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Badge_Attempt_FinishedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_badge_attempt_finished(inputs)
	if (locale === "ja") return ja_course_badge_attempt_finished(inputs)
	if (locale === "fr") return fr_course_badge_attempt_finished(inputs)
	return de_course_badge_attempt_finished(inputs)
});